export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./new-live-games.vue?vue&type=template&id=b6b29b4a"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/new-live-games.vue?vue&type=template&id=b6b29b4a
// module id = wEmw
// module chunks = 0